/**
 * Utility to generate crypto safe random numbers
 */
export function generateCryptoSafeRandom() {
  const random = new Uint32Array(1);
  if ('msCrypto' in window) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (<any>window).msCrypto.getRandomValues(random);
  } else if ('crypto' in window) {
    window.crypto.getRandomValues(random);
  } else {
    throw new Error(
      "The platform doesn't support generation of cryptographically safe randoms. Please disable the state flag and try again."
    );
  }
  return random[0];
}
